module.exports = __webpack_public_path__ + "images/baby_figzy88-afdb316aca6649c5d5723e1894b72313.jpg";